import {makeAjaxData} from "./tools.js";
import {leafletAutoHeightTitle} from './tools.js';
import {initBreadcrumb} from './breadcrumb.js';
import {initPriceWatchDogModal} from './priceWatchDog.js';
import './amp-breadcrumb';
import './store';
import './selectbox';
import './locality-lazy-loading';
import './category';

$(function ()
{
    $('.submit-form').change(function(e) {
        this.form.submit();
    });

    $("#searchBarIcon").click(function() {
        // odeslání formuláře po kliknutí na ikonku lupy
        $('#searchBarSubmit').trigger('click');
    });

    // Po 5s scroll povolíme vždy, protože reklamy mohou být blokovány např. adblockem,
    // tím pádem se to nedostane na onload reklam, kde to odblokováváme.
    setTimeout(function() {
        if (document.querySelectorAll('.no-scroll').length > 0) {
            document.body.classList.remove('no-scroll');
        }
    }, 5000);

    initBreadcrumb();
    loadItems();
    loadStores();
    initCuntomSnippet();
    initEmailModal();
    initPriceWatchDogModal();
});

function loadItems()
{
    $("#snippet-leaflets-loadButton, #snippet-leafletsArchive-loadButton").on('click', '#loadMoreItems', function ()
    {
        var parentElement = $(this).parent().parent();
        var loading = parentElement.find('#loadMoreItems');
        var spinner = parentElement.find('#spinner');
        
        var ajaxData = makeAjaxData($(this).data());
        
        $.nette.ajax({
            url: ajaxData['link'],
            data: ajaxData['params'],
            start: function ()
            {
                loading.hide();
                spinner.show();
            },
            complete: function ()
            {
                spinner.hide();
                loading.show();
                leafletAutoHeightTitle('.flyerName');
            }
        });
            
        
        return false;
    });
}

function loadStores() {
    $("#snippet-dealerLazyLoading-loadButton").on('click', '#loadMoreStores', function (e) {
        e.preventDefault();

        var parentElement = $(this).parent().parent();
        var loading = parentElement.find('#loadMoreStores');
        var spinner = parentElement.find('#spinner');
        
        var ajaxData = makeAjaxData($(this).data());

        $.nette.ajax({
            url: ajaxData['link'],
            data: ajaxData['params'],
            start: function () {
                loading.hide();
                spinner.show();
            },
            complete: function () {
                spinner.hide();
                loading.show();
            }
        });

        return false;
    });
}

function initCuntomSnippet()
{
    // abychom zabránili duplikaci listenerů, když je na stránce více prvků s custom-snippet classou, nejdřív využijeme off
    $('.custom-snippet').off('click').on('click', function(e) {
        e.preventDefault();

        let parentElement = $(this).parent();

        var loading = parentElement.find('.button');
        var spinner = parentElement.find('.spinner');

        let ajaxData = makeAjaxData($(this).data());

        $.nette.ajax({
            url: ajaxData['link'],
            data: ajaxData['params'],
            start: function () {
                loading.hide();
                spinner.show();
            },
            complete: function () {
                spinner.hide();
                loading.show();

                // reinicializujeme handler
                initCuntomSnippet();
            }
        });
    });
}

function initEmailModal()
{
    $('#emailModal').on('shown.bs.modal', function(e) {

        // zobrazíme spinner
        $('#emailModal .modal-body .spinner').show();

        // skryjeme form-body
        $('#emailModal .form-body').hide();

        // hlášku o ok chceme mít skrytou
        $('#emailModal .form-ok').hide();

        // URL, na kterou pošleme request pro zobrazení formu, máme v data atributu divu obalující form.
        const url = $(this).data('form-url');

        // ajax
        $.ajax({
            url: url,
            type: 'get',

            success: function(response) {

                // vypneme spinner
                $('#emailModal .modal-body .spinner').hide();

                // přidáme do body html
                $('#emailModal .form-body').html(response);

                // zobrazíme form-body
                $('#emailModal .form-body').show();

                // Display Modal
                // $('#empModal').modal('show');

                // znovu inicializujeme
                initEmailModal();
            }
        });
    });

    // submit formu
    $(".emailModal").submit(function(e) {

        e.preventDefault();

        var form = $(this);
        var url = form.attr('action');
        var formData = new FormData(this);

        // zobrazíme spinner
        $('#emailModal .modal-body .spinner').show();

        // skryjeme form-body
        $('#emailModal .form-body').hide();

        $.ajax({
            type: "POST",
            enctype: 'multipart/form-data',
            processData: false,
            contentType: false,
            cache: false,
            url: url,
            data: formData, // serializování elementu
            success: function(response, status, xhr)
            {

                // vypneme spinner
                $('#emailModal .modal-body .spinner').hide();

                let data = response;
                const contentType = xhr.getResponseHeader('Content-Type');

                // pokud mi přijde json, tak se form odeslal
                if (contentType.indexOf('json') > -1) {

                    // zobrazíme hlášku
                    $('#emailModal .form-ok').show();
                }
                // pokud přišel html, tak se něco ve formu nepovedlo
                else
                {
                    // zobrazíme form-body
                    $('#emailModal .form-body').show();
                }

                $('#emailModal .form-body').html(data);

                // znovu inicializujeme
                initEmailModal();
            }
        });
    });
}
